import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class TaskScreenFormatter extends Formatter {
}

// Расшифровки экрана по ходу запуска device-скрипта — «что скрипт видел»
// (DeviceScriptExecuteScreensController). Только чтение: строки заводит сам скрипт.
//
// Пути нестандартные, поэтому обе фабрики переопределены: лента вложена в запуск
// (tasks/{execute}/screens), а карточка лежит плоско (tasks/screens/{screen}) — сканы
// вне контекста запуска бессмысленны, но открывать их по одному удобнее по короткому пути.
export default class ApiTaskScreen extends ApiModelWithAuth {
    pathDef = 'authorized/admin/tasks';
    formatterItem = TaskScreenFormatter.Item;

    // Лента сканов ОДНОГО запуска, по возрастанию id (в порядке съёмки). per_page до 200.
    static IndexOfExecute(executeId, params = {}) {
        const api = super.Index(params);
        api.paths = { 'index': `${api.pathDef}/${executeId}/screens` };

        return api;
    }

    // Карточка скана: здесь приходит полный result (в ленте его нет — она бы раздулась).
    static Show(screenId) {
        const api = super.Show(screenId);
        api.paths = { 'show': `${api.pathDef}/screens` };

        return api;
    }
}
